import React, {useState,useEffect} from "react";
import "../styleSheets/carouselStyle.css"
import {useImages} from "./useImages";
export function Carousel(){
    const images = useImages('carousel');

    const [currentImg,setCurrentImg] = useState(0);
    useEffect(()=>{
        const interval = setInterval(()=>{
            setCurrentImg((prevState)=>(prevState+1) %images.length);
        },3000);
        return () => clearInterval(interval);
    },[images.length]);

    return (
        <div className={"carousel full-bleed"}>
            <div className={"c_img"}>
                <img src ={images[currentImg]?.imageURL} alt = "Carousel"/>
                <div className={"dots"}>
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === currentImg ? "dot active" : "dot"}
                            onClick={() => setCurrentImg(index)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}